import React from 'react';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
//import { accessControl } from '../../helpers/accessControl';
//import { CREATE_USER_PERMISSION } from '../../constants/permissions';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        backgroundColor: '#edeeef',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
    stepper: {
        "& .MuiStepIcon-active": {
            color: '#2E2757'
            //display: "none"
        },
        "& .MuiStepLabel-label": {
            //fontFamily: 'MyriadPro-Bold'
        },
    },
}));


const UserRegisterStepper = props => {
    const { UserRegisterForm, steps, activeStep, UserRegisterSecondForm } = props
    const classes = useStyles();

    const handleReset = () => {
        //   setActiveStep(0);
    };
    /* const handleOnSubmit = (data) => {
    } */
    const getStepContent = (stepIndex, classes) => {
        switch (stepIndex) {
            case 0:
                return UserRegisterForm;
            case 1:
                return UserRegisterSecondForm;
            case 2:
                return 'This is the bit I really care about!';
            default:
                return 'Unknown stepIndex';
        }
    }
    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={12} style={{ padding: '30px' }} container justifyContent='center'>
                    <Typography className={classes.instructions}>Solicitud de registro</Typography>
                    <Stepper activeStep={activeStep} style={{ backgroundColor: '#edeeef' }} className={classes.stepper} alternativeLabel>
                        {steps.map(form => (
                            <Step key={form}>
                                <StepLabel>{form}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <div>
                        {activeStep === steps.length ? (
                            <div>
                                <Typography className={classes.instructions}>Usuario registrado</Typography>
                                <Button onClick={handleReset}>Nuevo usuario</Button>
                            </div>
                        ) : (
                            <div>
                                {getStepContent(activeStep, classes)}
                            </div>
                        )}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

UserRegisterStepper.propTypes = {

};

export default /*  accessControl([CREATE_USER_PERMISSION]) */(UserRegisterStepper);

/*
    <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.backButton}
                    >
                        Back
                    </Button>
                    <Button variant="contained" color="primary" >
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                    </div>
*/